<template>
  <div class="RouteContainer" :style="{ overflow: helperState.overflow }" style="height: 100vh">
    <app-audio :src="'./static/audio/' + wolfContent.audio"></app-audio>
    <app-background :backgroundImg="'./static/images/explore/' + wolfContent.backgroundImg"></app-background>

    <transition 
    :name="wolfState.animation" 
    mode="out-in" 
    v-on:after-enter="setProp('helpers', 'overflow', 'visible')"
    v-on:before-leave="setProp('helpers', 'overflow', 'hidden')" 
    v-on:after-leave="setProp('helpers', 'overflow', 'hidden')">
      <!-- <keep-alive> -->
        <component :is="wolfState.currentView"></component>
      <!-- </keep-alive> -->
    </transition>

  </div>
</template>

<script>
import appAudio from './../partials/audio'
import appBackground from './../partials/background'
import appWolfmap from './../explore/wolf-map'
import appWolfDetail from './../explore/wolf-detail'

export default {
  name: 'exploreTheWolf',

  components: {
    appAudio,
    appBackground,
    appWolfmap,
    appWolfDetail
  },

  data () {
    return {
      overflow: 'visible'
    }
  },

  beforeCreate () {
    this.$store.dispatch('getLocalData', 'explore')
  },

  computed: {
    helperState () {
      return this.$store.getters.helperState
    },

    wolfContent () {
      return this.$store.getters.wolfContent
    },

    wolfState () {
      return this.$store.getters.wolfState
    }
  },

  methods: {
    setProp (parent, key, value) {
      let payload = {
        parent: parent,
        key: key,
        value: value
      }
      this.$store.dispatch('setProp', payload)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/routes/explore-the-wolf.vue